import { Film, Tv } from 'lucide-react'

interface Title {
  id: string
  name: string
  nameJa?: string
  posterUrl?: string
  backdropUrl?: string
  viewCount: number
  mediaType: 'movie' | 'tv'
  genres: string[]
  firstWatched: string
  lastWatched: string
  tmdbId?: number
}

interface AlbumCardProps {
  title: Title
  onClick?: () => void
}

export function AlbumCard({ title, onClick }: AlbumCardProps) {
  return (
    <div
      className="group relative aspect-[2/3] rounded-lg overflow-hidden bg-card cursor-pointer shadow-md hover:shadow-xl transition-all duration-300 w-full"
      onClick={onClick}
    >
      {title.posterUrl ? (
        <img
          src={title.posterUrl}
          alt={title.name}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/20 to-primary/5">
          {title.mediaType === 'movie' ? (
            <Film className="h-16 w-16 text-muted-foreground" />
          ) : (
            <Tv className="h-16 w-16 text-muted-foreground" />
          )}
        </div>
      )}

      <div className="absolute top-2 right-2 netflix-gradient px-2 py-1 rounded text-xs font-bold text-white shadow-lg">
        {title.viewCount}回
      </div>

      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-white font-bold text-sm line-clamp-2 mb-1">
            {title.name}
          </h3>
          <p className="text-white/90 text-xs mb-2">
            {title.viewCount}回視聴
          </p>
          {title.genres.length > 0 && (
            <p className="text-white/70 text-xs">
              {title.genres.slice(0, 2).join(', ')}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
